import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'college-profile-page.publish-error-modal.header',
    defaultMessage: 'Publishing Failed',
  },
  content: {
    id: 'college-profile-page.publish-error-modal.title',
    defaultMessage: 'It looks like there were connectivity issues.',
  },
  retry: {
    id: 'college-profile-page.publish-error-modal.content',
    defaultMessage: 'Want to retry publishing?',
  },
  cancelButton: {
    id: 'college-profile-page.publish-error-modal.cancelBtn',
    defaultMessage: 'Cancel',
  },
  submitButton: {
    id: 'college-profile-page.publish-error-modal.publishBtn',
    defaultMessage: 'Publish',
  },
});

export default messages;
